module.exports = __webpack_public_path__ + "media/src/images/icons/people/primary-afc2550ad890a435de50349ad8fa48a8.svg";